module.exports = __webpack_public_path__ + "static/media/lens_classic-Sweet.c6020452.png";